import { createWithThemeDecorator } from '../utils';
import { ThemeConsumer } from '../theme';
export var withTheme = createWithThemeDecorator(ThemeConsumer);
